import { render, staticRenderFns } from "./LottieAnimation.vue?vue&type=template&id=4a21e50b&"
import script from "./LottieAnimation.vue?vue&type=script&lang=ts&"
export * from "./LottieAnimation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4a21e50b', component.options)
    } else {
      api.reload('4a21e50b', component.options)
    }
    module.hot.accept("./LottieAnimation.vue?vue&type=template&id=4a21e50b&", function () {
      api.rerender('4a21e50b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/LottieAnimation.vue"
export default component.exports